<template>
    <div class="h-full">
        <div v-if="!isMobile" class="bg-page-game pb-5 h-full">
            <div class="relative">
                <div class="top-0 left-0 w-full" :class="{'absolute': bannerStore.ready && banners.length > 0}">
                    <MerchantMarqueeAnnounce></MerchantMarqueeAnnounce>
                </div>
                <div v-if="!bannerStore.ready" class="skeleton w-full">
                    <div style="width: 100%; padding-top: calc(100% / 3.2);"></div>
                </div>
                <div v-if="bannerStore.ready && banners.length > 0" class="relative overflow-hidden">
                    <CardSlider :cards="banners" v-model="slide" :config="{maxDegree: 0, cardDistance: 0, maxScale: 0}">
                        <template #default={card}>
                            <div @click="goBannerURL(card.link)" class="relative overflow-hidden" :class="card.link ? 'cursor-pointer' : ''">
                                <div style="width: 100%; padding-top: calc(100% / 3.2);"></div>
                                <img class="pointer-events-none w-full absolute top-0 left-0" :key="card.id" :src="card.desktop_img" :alt="`banner_${card.id}`"/>
                            </div>
                        </template>
                    </CardSlider>
                </div>
            </div>
            <div class="container">
				<GameContainer type="fish"></GameContainer>   
			</div>
        </div>
        <MerchantGameContainerMobile v-if="isMobile" type="fish"></MerchantGameContainerMobile>
    </div>
</template>

<script setup>
const { isMobile } = useDevice();
const dashboardStore = useDashboardStore();
const gamesStore = useGamesStore()
const providerStore = useProviderStore()
const userStore = useUserStore()

const readyWatcher = watchEffect(() => {
    if (providerStore.ready && (!userStore.loggedIn || (userStore.loggedIn && dashboardStore.ready))) {
        gamesStore.getGames('fish')
        readyWatcher()
    }
}, {
    flush: 'post'
})

watch(() => userStore.loggedIn, () => {
    gamesStore.getGames('fish')
})

const slide = ref(0);
const {locale} = useI18n()
const bannerStore = useBannerStore()
const banners = computed(() => {
    if (!bannerStore.ready) return []
    var bannerList = [];
    if (bannerStore.data?.[locale.value]?.fish) {
        var bannerPath = isMobile ? 'mobile_img' : 'desktop_img';
        for (let i = 0; i < bannerStore.data[locale.value].fish.length; i++) {
            if (bannerStore.data[locale.value].fish[i][bannerPath]) {
                bannerList.push(bannerStore.data[locale.value].fish[i]);
            }
        }
    }
    return bannerList;
})
const goBannerURL = (url) => {
    if (typeof url != 'string') {
        return
    }
    const now = Date.now()
    if (url.indexOf('?') > - 1) {
        url += `&qt=${now}`
    }
    else {
        url += `?qt=${now}`
    }
    if (url.indexOf('http') > -1) {
        window.open(url, '_blank');
    } else {
        window.open(`${window.location.origin}${url}`, '_blank');
    }
}
</script>